import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';
import ApiResponse from '../../components/message/ApiResponse';

import { getCurrentResource, getDefinedItem } from '../../util/tools';
import { FORM_REQUEST_TABLE } from '../../util/consts/forms';
import {
	USER_PROFILE_API_URL, ACTION_SEND_REQUEST_BY_EMAIL_API_URL, performApiRequest 
} from '../../util/restapi';

import iconSendEmail from '../../assets/icons/png24x24/send_message.png';

const FORM_STATE_GET_DATA = 'd';
const FORM_STATE_WAITING = 'w';
const FORM_STATE_COMPLETE = 'c';

class RequestListPage extends Component {
	
	constructor(props) {
		super(props);

		this.resource = getCurrentResource().pages.tableform.RequestList;
		let paramCacheId = props.match.params.param;
		this.refSendEmailModal = React.createRef();
		this.refRateView = React.createRef();

		this.rvContext = {
			form: FORM_REQUEST_TABLE,
			data: []
		};
		this.rvOptions = {
			form: FORM_REQUEST_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			controlPanelTools: this.controlPanelTools(),
			transition: null,
			//hideButtonAdd: true,
			//hideButtonEdit: true,
			hideButtonMergeInstances: true,
			hideButtonChangeOwner: true,
			hideButtonFieldUpdate: true,
			hideButtonGlobalIdUpdate: true,
			//hideButtonDelete: true,
			//hideButtonShowHtml: true,
			//hideButtonHtml: true,
			hideButtonPdf: true,
			hideButtonXml: true,
			//hideButtonTransition: true,
			//hideButtonUshExport: true,
			//hideButtonUshImport: true,
			hideButtonSendEmail: true,
		};

		this.state = {
			isSendEmailModalOpen: false,
		}
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}

	controlPanelTools = () => {
		return (
			<div style={{textAlign: 'left', marginLeft: '20px'}}>
				<ControlPanelButtonSendEmail holder={this} />
			</div>			
		);
	}

	openSendEmailModal = () => {
		this.refSendEmailModal.current.init(true);
		this.setState({ isSendEmailModalOpen: true});	
	}
	closeSendEmailModal = () => {
		this.setState({ isSendEmailModalOpen: false });	
	}

	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView ref={this.refRateView} rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
				<SendEmailModal ref={this.refSendEmailModal} page={this} 
					isModalOpen={this.state.isSendEmailModalOpen} 
					close={this.closeSendEmailModal} 
				/>
			</React.Fragment>
		)
	}
	
}

function ControlPanelButtonSendEmail(props) {
	
	return (
		<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
			 onClick={props.holder.openSendEmailModal}
			 title={props.holder.resource.buttonSendEmailTooltip} 
		>
			<img src={iconSendEmail} />
		</button>			
	);
}

class SendEmailModal extends React.Component {

	constructor(props) {
		super(props);
		this.userProfile = null;
		this.apiResponse = { message: '', log: ''};
		this.init(false);
		this.state = {
			dirtyCount: 0,
			formState: FORM_STATE_GET_DATA,
		};
	}
	componentDidMount = async () => {
		let response = await performApiRequest( USER_PROFILE_API_URL, {} );
		if( ! response.success ) {
			this.apiResponse = response;
			this.setState({formState: FORM_STATE_COMPLETE});
			return;
		}
		this.userProfile = response.data;
		
		this.setState({formState: FORM_STATE_COMPLETE});
	}
	init = (doSetState) => {
		let from = getDefinedItem(this, ['userProfile', 'user', 'contact', 'email'], '');

		this.request = {
			listMarked: [],
			querySelected: null, 
			mode: 'marked',
			from: from,
			to: '',
			subject: '',
		}
		this.apiResponse = { message: '', log: ''};

		if( doSetState ) {
			let rateView = this.props.page.refRateView.current;
			this.request.listMarked = rateView.getSelectedIds();
			this.request.querySelected = rateView.query;
			this.setState({
				dirtyCount: 0,
				formState: FORM_STATE_GET_DATA,
			});
		}
	}
	
	handleInputEdit = (e) => {
		const {name, value} = e.target;
		if( name == 'mode' ) {
			this.request.mode = value;
		} else if( name == 'to' ) {
			this.request.to = value;
		} else if( name == 'from' ) {
			this.request.from = value;
		} else if( name == 'subject' ) {
			this.request.subject = value;
		} 
		this.setState({dirtyCount: this.state.dirtyCount+1})
	}

	sendEmail = async () => {
		this.setState({formState: FORM_STATE_WAITING});
		this.apiResponse = await performApiRequest( ACTION_SEND_REQUEST_BY_EMAIL_API_URL, this.request );
		this.setState({formState: FORM_STATE_COMPLETE});
	}
	
	render() {
		let res = this.props.page.resource;
		let divWaiting = null;
		let divMessage = null;
		let inputDisabled = this.state.formState != FORM_STATE_GET_DATA;
		if( this.state.formState == FORM_STATE_WAITING ) {
			divWaiting = <div style={{textAlign: 'center', padding: '7px'}}>{res.msgWait}</div>
		} else if( this.state.formState == FORM_STATE_COMPLETE ) {
			let defaultMessage = this.apiResponse.success ? res.msgSuccessfullySent : res.msgSendError;
			divMessage = <ApiResponse response={this.apiResponse} defaultMessage={defaultMessage} />
		}
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal}
				closeOnOverlayClick={false} animationDuration={1}
			>
				<div>
					<div style={{fontSize: '16pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0'}}>
						{res.modalSendEmailTitle}
					</div>
					<div style={{marginTop: '10px', padding: '10px'}}>
						<div>
							<span style={{marginRight: '10px'}}>{res.labelMode}</span>
							<select name='mode' value={this.request.mode} onChange={this.handleInputEdit}>
								<option value='marked'>{res.optionMarked}</option>
								<option value='selected'>{res.optionSelected}</option>
							</select>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelTo}</div>
							<input type='text' name='to' value={this.request.to} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelFrom}</div>
							<input type='text' name='from' value={this.request.from} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
						</div>
						<div style={{display: 'flex', marginTop: '20px'}}>
							<div style={{marginRight: '10px'}}>{res.labelSubject}</div>
							<input type='text'name='subject' value={this.request.subject} style={{flexGrow: '1'}}  onChange={this.handleInputEdit}/>
						</div>
					</div>
					{divWaiting}
					{divMessage}
					<div style={{marginTop: '7px', padding: '10px', marginRight: '15px', textAlign: 'right'}}>
						<button onClick={this.sendEmail} disabled={inputDisabled} title={res.buttonSendTooltip}>{res.buttonSend}</button>
					</div>
				</div>
			</Modal>
		);
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

export default RequestListPage;
